/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-badge-counter {
  align-items: center;
  background-color: var(--qds-theme-feedback-message-neutral);
  border-radius: var(--qds-feedback-rounded-border-radius);
  color: var(--qds-theme-feedback-message-neutral-contrast);
  display: flex;
  font: var(--qds-feedback-badge-counter-standard-text);
  height: var(--qds-feedback-badge-counter-standard-height);
  justify-content: center;
  margin: 0;
  padding-inline: var(--qds-feedback-badge-counter-standard-padding-horizontal);
  text-align: center;
}

.qds-stroke-ring {
  border: var(--qds-feedback-badge-border-width) solid
    var(--qds-theme-feedback-message-neutral-contrast);
}

.qds-sr-only {
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
}

[data-importance='emphasized'] {
  background-color: var(--qds-theme-signature-color-contrast);
  color: var(--qds-theme-signature-color-default);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-signature-color-default);
  }
}

[data-importance='subdued'] {
  background-color: var(--qds-theme-feedback-message-informational);
  color: var(--qds-theme-feedback-message-informational-contrast);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-informational-contrast);
  }
}

[data-importance='destructive'] {
  background-color: var(--qds-theme-feedback-message-critical-contrast);
  color: var(--qds-theme-feedback-message-critical);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-critical);
  }
}

[data-importance='subdued-destructive'] {
  color: var(--qds-theme-feedback-message-critical-contrast);
  background-color: var(--qds-theme-feedback-message-critical);

  &.qds-stroke-ring {
    border-color: var(--qds-theme-feedback-message-critical-contrast);
  }
}

[data-size='small'] {
  font: var(--qds-feedback-badge-counter-small-text);
  height: var(--qds-feedback-badge-counter-small-height);
  padding-inline: var(--qds-feedback-badge-counter-small-padding-horizontal);
}

[data-size='large'] {
  font: var(--qds-feedback-badge-counter-large-text);
  height: var(--qds-feedback-badge-counter-large-height);
  padding-inline: var(--qds-feedback-badge-counter-large-padding-horizontal);
}

[data-size='hero'] {
  font: var(--qds-feedback-badge-counter-hero-text);
  height: var(--qds-feedback-badge-counter-hero-height);
  padding-inline: var(--qds-feedback-badge-counter-hero-padding-horizontal);
}
